import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RouteParamName} from '../../../data/constants/route.constants';
import {switchMap} from 'rxjs/operators';
import {of, throwError} from 'rxjs';
import {environment} from '@env';
import {NP_INSTANCE_CONFIG} from '../../../data/constants/np-instance.constants';
import {Constantes} from '@nextpage/np-sdk-data';

@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    standalone: true
})
export class BaseComponent {
    protected instanceId: string;
    private _activatedRoute = inject(ActivatedRoute);
    private constants = inject(Constantes);

    constructor() {
    }

    // TODO: Delete after Angular updation to v16 and use parameter binding
    afterIntInstanceConfig() {
        return this._activatedRoute.paramMap
            .pipe(
                switchMap(params => {
                    console.log('params : ', params)
                    if (params && params.has(RouteParamName.INSTANCE_ID)) {
                        this.instanceId = params.get(RouteParamName.INSTANCE_ID);
                        this._initEnvironment();
                        of(params);
                    } else {
                        return of(null);
                    }
                })
            );
    }

    private _initEnvironment () {
        const instance = NP_INSTANCE_CONFIG.get(this.instanceId);
        environment.instance = instance;
        this.constants.baseUrl = instance.npBaseUrl;
    }


}
